import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import { Toast } from "@nutui/nutui";
import baseUrl from "./requestUrl"
import router from '@/router/index'
/**
 * 用axios发送请求时，后台保存了session，但是在前台每次刷新页面的时候，发现从后端请求到的session值每次都不一样。
 * 把默认配置withCredentials改为true，就可以允许跨域携带cookie信息了。
 */
axios.defaults.withCredentials = true; //携带cookie
var cntextPath = ""

/**
 * 通用请求方法
 * url : 地址
 * method : 'post' , 'get'
 * data : 请求数据
 * then : 请求成功后调用
 * fail : 请求失败后调用
 * complete : 请求完成后调用
 * @param {*} param0 
 */
function requestUtil({ url, method, data, then, fail, complete, needLogin, headers, needQs }) {
    var apiUrl = baseUrl.getBaseUrl()

    if (data == null) {
        data = {};
    }

    // 处理空值
    var keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
        if (keys[i] === null || keys[i] === undefined || keys[i] === "null" || keys[i] === "undefined") {
            delete data[keys[i]];
        }
    }

    url = apiUrl + cntextPath + url
    // 处理get请求的参数

    if (method.toLocaleLowerCase() === "get" && Object.keys(data).length > 0) {
        let leng = url.length;
        if (url.substring(leng - 1, leng) !== "?") {
            url = url + "?";
        }

        var keys = Object.keys(data)
        for (let i = 0; i < keys.length; i++) {
            url = url + keys[i] + "=" + data[keys[i]] + (i === keys.length - 1 ? "" : "&")
        }
    }

    url = encodeURI(url)
    // var header;

    if (headers == null) {
        if (method.toLocaleLowerCase() == "get") {
            axios.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8';
        }
        if (method.toLocaleLowerCase() == "post") {
            axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
        }
    }
    if (needQs != false) {
        data = qs.stringify(data)
    }

    axios({
        method: method,
        url: url,
        headers: headers,
        data: data
    }).then((response) => {
        if (response.data.code === 302 ){
            console.log(response)
            var ua = navigator.userAgent.toLowerCase();
            var isWeixin = ua.indexOf("micromessenger") != -1;
            if (isWeixin) {
                //微信浏览器打开
                url = window.location.href; /* 获取完整URL */
                window.location.href = baseUrl.getBaseUrl() + "/api/login/wxLogin?src=" + encodeURIComponent(url)
            }else{
                alert("请在微信浏览器打开")
            }
        }
        if (response.data.code === 0) {
            // 成功
            if (then != null) {
                then(response.data)
            }
        } else if (response.data.code === -1001) {
            // 需要登陆
            // if (needLogin != null) {
            //     needLogin(response.data)
            // }
            //其他浏览器打开
            console.log(window.$route)

            var ua = navigator.userAgent.toLowerCase();
            var isWeixin = ua.indexOf("micromessenger") != -1;
            if (isWeixin) {
                //微信浏览器打开
                url = window.location.href; /* 获取完整URL */
                window.location.href = baseUrl.getBaseUrl() + "/api/login/wxLogin?src=" + encodeURIComponent(url)
            } else {
                if (needLogin != false) {
                    router.push({
                        path: "/login",
                        query: { path: window.$route.path, query: JSON.stringify(window.$route.query) }
                    })
                }
            }
        } else if (response.data.code === -1002) {
            // 需要注册公司
            router.push({
                path: "/bindPhone",
                query: { path: window.$route.path }
            })

        } else if (response.data.code === -1) {
            Toast.text(response.data.msg)
            // 服务器异常
            // 执行失败的方法
            if (fail != null) {
                fail(response)
            }
        }
    }).catch((error) => {
        console.log(error)
        if (fail != null) {
            fail(error)
        }
        if (complete != null) {
            complete(error);
        }
    })

}

export default {
    install: function (Vue) {
        Vue.prototype.$requestUtil = ({ url, method, data, then, fail, complete, needLogin, headers, needQs }) => requestUtil({ url, method, data, then, fail, complete, needLogin, headers, needQs })
    },
    requestUtil
}




// WEBPACK FOOTER //
// ./src/common/js/requestUtil.js